import { render, staticRenderFns } from "./Floor.vue?vue&type=template&id=0bf8fd1e&scoped=true"
import script from "./Floor.vue?vue&type=script&lang=js"
export * from "./Floor.vue?vue&type=script&lang=js"
import style0 from "./Floor.vue?vue&type=style&index=0&id=0bf8fd1e&prod&scoped=scoped&lang=less"
import style1 from "./Floor.vue?vue&type=style&index=1&id=0bf8fd1e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf8fd1e",
  null
  
)

export default component.exports